import { render, staticRenderFns } from "./OpenConsentForm.vue?vue&type=template&id=50a0f45b&"
import script from "./OpenConsentForm.vue?vue&type=script&lang=js&"
export * from "./OpenConsentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports